export const LINK_TERMOS_SERVICOS = `https://taglivros.com/termos-de-uso`

export const LINK_REGULAMENTO_INDICACAO_AMIGOS = 'https://taglivros.com/regulamento-indicacao-amigos'

export const LINK_PRIVACIDADE_SEGURANCA = 'https://taglivros.com/politica-de-privacidade-e-seguranca'

export const TERMOS_SERVICOS = 'Termos de Serviço'

export const REGULAMENTO_INDICACAO_AMIGOS = 'Regulamento Indicação de Amigo'

export const PRIVACIDADE_SEGURANCA = 'Privacidade e Segurança'
